import admissionActions from './admission.actions';
import admissionMedicalOrdersActions from './admissionMedicalOrders.actions';
import admissionPaymentActions from './admissionPayment.actions';
import admissionQuestionsActions from './admissionQuestions.actions';
import backofficeActions from './backoffice.actions';
import docuSignActions from './docuSign.actions';
import ocrActions from './ocr.actions';
import paperlessActions from './paperless.actions';
import trackingActions from './tracking.actions';

export const actionsModules = {
  ...admissionActions,
  ...admissionMedicalOrdersActions,
  ...admissionPaymentActions,
  ...admissionQuestionsActions,
  ...backofficeActions,
  ...docuSignActions,
  ...ocrActions,
  ...paperlessActions,
  ...trackingActions,
};
